import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logoLinkedin.svg'


const _withScopeId = n => (_pushScopeId("data-v-6b5f2653"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "contact",
  class: "flex w-screen"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col w-full my-auto ml-32 text-2xl\" data-v-6b5f2653><a href=\"tel:+33650533308\" data-v-6b5f2653><span class=\"material-icons md-36 text-green-600 mr-3\" data-v-6b5f2653>phone</span>+33 6 50 53 33 08</a><a href=\"mailto:koeltheo@gmail.com\" data-v-6b5f2653><span class=\"material-icons md-36 text-green-600 mr-3\" data-v-6b5f2653>mail</span>koeltheo@gmail.com</a><a href=\"https://www.linkedin.com/in/th%C3%A9o-ko%C3%ABl-b5b50915b/\" data-v-6b5f2653><img class=\"w-8 mr-3\" src=\"" + _imports_0 + "\" data-v-6b5f2653> Théo Koël</a></div>", 1)
const _hoisted_3 = { class: "titleSection mr-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('header.sommaire.6')), 1)
  ]))
}